document.addEventListener("DOMContentLoaded", () => {
    const counters = document.querySelectorAll('.counter');
    const counters1 = document.querySelectorAll('.counter1');
    const counters2 = document.querySelectorAll('.counter2');

    const options = {
        root: null,
        threshold: 0.1 // Trigger when 10% of the element is in view
    };

    const countUp = (counter, target, suffix) => {
        let startingCount = 0;
        const increment = target / 100;

        const updateCount = () => {
            if (startingCount < target) {
                startingCount += increment;
                counter.innerText = Math.round(startingCount);
                requestAnimationFrame(updateCount);
            } else {
                counter.innerText = target + (suffix || '');
            }
        };

        updateCount();
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const counter = entry.target;
                if (counter.classList.contains('counter')) {
                    countUp(counter, +counter.getAttribute('data-count0'), '%');
                } else if (counter.classList.contains('counter1')) {
                    countUp(counter, +counter.getAttribute('data-count1'), '+');
                } else if (counter.classList.contains('counter2')) {
                    countUp(counter, +counter.getAttribute('data-count2'), 'k+');
                } 
                observer.unobserve(counter); // Stop observing after counting
            }
        });
    }, options);

    // Observe each counter element
    counters.forEach(counter => observer.observe(counter));
    counters1.forEach(counter1 => observer.observe(counter1));
    counters2.forEach(counter2 => observer.observe(counter2));
});
